<div class="item">
  <ion-row>
    <ion-col class="icon">
      <app-game-icon [icon]="item.icon"></app-game-icon>
    </ion-col>

    <ion-col class="text">
      <div class="name" [ngClass]="[itemClass]">
        {{ item.name }}
      </div>

      <ng-container *ngIf="showEffectInfo">
        <div class="effect" *ngFor="let ability of item.abilities; trackBy: trackBy">
          <ng-container *ngIf="getAbility(ability.abilityName || '') as abilityRef" [class.hidden]="!abilityRef">
            <strong>{{ abilityRef.name }}</strong>: {{ abilityRef.description }}
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="showEatInfo && item.type === 'Food'">
        <div class="effect" *ngIf="(item.oocHealth || 0) > 0">
          <strong>Heals</strong>: {{ item.oocHealth }} HP
        </div>

        <div class="effect" *ngIf="(item.oocEnergy || 0) > 0">
          <strong>Restores</strong>: {{ item.oocEnergy }} Energy
        </div>
      </ng-container>

      <div class="effect-uses" *ngIf="(showEffectInfo || showEatInfo) && showUses">
        <ion-text color="energy">{{ item.durability }} Use(s)</ion-text>
      </div>
    </ion-col>
  </ion-row>
</div>
